import { createI18n } from 'vue-i18n'

const i18n = createI18n({
    legacy: 'false',
    locale: document.documentElement.lang,
    fallbackLocale: 'nl',
    globalInjection: true,
    messages: {
        nl: {},
        en: {}
    }
})

export async function loadLocalesAsync(i18n, lang) {
    try {
        const request = new Request(`/translations/${lang}.json`, {
            cache: 'no-cache'
        })
        const response = await fetch(request)
        const data = await response.json()
        i18n.global.setLocaleMessage(lang, data)
        return i18n
    } catch (error) {
        return i18n
    }
}

export default i18n
